import React, { useRef, useEffect } from 'react';
import type { ChatMessage, FollowUpAction } from '../types/protocol';
import { MessageBubble } from './MessageBubble';

interface MessageListProps {
  messages: ChatMessage[];
  isThinking: boolean;
  onConfirm?: () => void;
  onEdit?: (stepId: string) => void;
  onAction?: (action: FollowUpAction) => void;
  devMode?: boolean;
}

export function MessageList({ messages, isThinking, onConfirm, onEdit, onAction, devMode }: MessageListProps): React.ReactElement {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isThinking]);

  return (
    <div className="sp-message-list">
      {messages.map((msg) => (
        <MessageBubble
          key={msg.id}
          message={msg}
          onConfirm={onConfirm}
          onEdit={onEdit}
          onAction={onAction}
          devMode={devMode}
        />
      ))}
      {isThinking && (
        <div className="sp-bubble sp-bubble-assistant">
          <div className="sp-thinking">
            <span className="sp-dot" />
            <span className="sp-dot" />
            <span className="sp-dot" />
          </div>
        </div>
      )}
      <div ref={bottomRef} />
    </div>
  );
}
